import getStore from '../store/store';

/**
 * Util to get published status of the booking page from store.
 */
export default function getPublishedStatus(): boolean {
    let store = getStore();
    let settings = store.publishingSettings;
    return (settings && settings.IsPublished && store.isAnonymousSharingEnabled) || false;
}
